import { EPLEDGE_HOLDING, EPLEDGE_HOLDING_OTP_ERROR, EPLEDGE_HOLDING_OTP_HIDE_ERROR, EPLEDGE_HOLDING_OTP_START_LOADER, EPLEDGE_HOLDING_OTP_STOP_LOADER, } from "../interface/iEpledgeHolding";
const initState = {
    data: {},
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const epledgeHoldingReducer = (state = initState, action) => {
    switch (action.type) {
        case EPLEDGE_HOLDING: {
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        }
        case EPLEDGE_HOLDING_OTP_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case EPLEDGE_HOLDING_OTP_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case EPLEDGE_HOLDING_OTP_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case EPLEDGE_HOLDING_OTP_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default epledgeHoldingReducer;
